import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../components/context/auth/AuthState";
import { useData } from "../components/context/data/DataState";
import leadshipIcon from "../assests/images/leadership_860398.png";
import leadshipIconGreen from "../assests/images/leadership-green.png";

import {
  Menu,
  LogOut,
  UserPlus,
  Users2,
  ChevronLeft,
  Home,
  UserCircle,
  UserCog,
  FileEdit,
  HelpCircle,
} from "lucide-react";
import { Button } from "../components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../components/ui/sheet";
import { Separator } from "../components/ui/separator";
import { useTour } from "@reactour/tour";
import { cn } from "../lib/utils";

const Layout = ({ footer, viewMenu }) => {
  let navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [menu, setmenu] = useState(false);
  const [currentRoute, setcurrentRoute] = useState("");
  const { changeCommunityId, data, communityId } = useData();
  const { setIsOpen } = useTour();
  
  function handleClick(val) {
    setmenu(val);
  }
  
  const location = useLocation();
  const { currentUser, logout } = useAuth();

  function handleSignOut() {
    logout();
    navigate("/login");
  }

  useEffect(() => {
    setmenu(false);
    if (location.pathname !== currentRoute) {
      setcurrentRoute(location.pathname);
    }
  }, [location]);

  return (
    <>
      <header className="bg-primary text-primary-foreground shadow-md">
        <div className="flex items-center justify-between px-4 py-3">
          {viewMenu && (
            <Sheet open={menu} onOpenChange={setmenu}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-white hover:bg-primary/90">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[250px]">
                <SheetHeader>
                  <SheetTitle>Menu</SheetTitle>
                </SheetHeader>
                <div className="mt-4">
                  <div className="space-y-1">
                    {Object.values(data.community || {}).map((item) => (
                      <button
                        key={item.community_id}
                        onClick={() => {
                          changeCommunityId(item.community_id);
                          navigate("/");
                          setmenu(false);
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-accent rounded-md transition-colors"
                      >
                        <Users2 className="h-5 w-5" />
                        <span>{item.community_name}</span>
                      </button>
                    ))}
                    
                    <Separator className="my-2" />
                    
                    <button
                      onClick={() => {
                        navigate("/join");
                        setmenu(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-accent rounded-md transition-colors"
                    >
                      <UserPlus className="h-5 w-5" />
                      <span>Join a Community</span>
                    </button>
                    
                    <Separator className="my-2" />
                    
                    <button
                      onClick={() => {
                        navigate("/admin");
                        setmenu(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-accent rounded-md transition-colors"
                    >
                      <UserCog className="h-5 w-5" />
                      <span>Switch to Admin</span>
                    </button>
                    
                    <button
                      onClick={() => {
                        handleSignOut();
                        setmenu(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-accent rounded-md transition-colors"
                    >
                      <LogOut className="h-5 w-5" />
                      <span>Logout</span>
                    </button>
                    
                    <Separator className="my-2" />
                    
                    <button
                      onClick={() => {
                        navigate("");
                        setIsOpen(true);
                        setmenu(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-accent rounded-md transition-colors"
                    >
                      <HelpCircle className="h-5 w-5" />
                      <span>Tutorial</span>
                    </button>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          )}
          <h1 className="text-xl font-semibold flex-1 text-center">HealthierME</h1>
          {viewMenu && <div className="w-10" />} {/* Spacer for centering */}
        </div>
      </header>

      <main className="home-main">
        <Outlet context={[menu, setmenu]} />
      </main>

      {footer && (
        <footer className="bg-primary text-white fixed bottom-0 left-0 right-0 h-[70px] flex items-center justify-evenly shadow-lg">
          <button
            onClick={() => navigate(-1)}
            className="flex flex-col items-center justify-center gap-1 px-3 py-2 hover:bg-primary/90 rounded transition-colors"
          >
            <ChevronLeft className="h-6 w-6" />
            <span className="text-xs">Back</span>
          </button>
          
          <button
            onClick={() => navigate("")}
            className={cn(
              "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded transition-colors",
              currentRoute === "/" 
                ? "bg-white/20" 
                : "hover:bg-primary/90"
            )}
          >
            <Home className="h-6 w-6" />
            <span className="text-xs">Home</span>
          </button>
          
          <button
            onClick={() => navigate(`report/${communityId}`)}
            className={cn(
              "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded transition-colors",
              currentRoute.startsWith("/report") 
                ? "bg-white/20" 
                : "hover:bg-primary/90"
            )}
          >
            <img
              src={
                currentRoute.startsWith("/report")
                  ? leadshipIconGreen
                  : leadshipIcon
              }
              alt="leadership board"
              className="h-6 w-6"
            />
            <span className="text-xs">Leader Board</span>
          </button>
          
          <button
            onClick={() => navigate(`score/${communityId}`)}
            className={cn(
              "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded transition-colors",
              currentRoute.startsWith("/score") 
                ? "bg-white/20" 
                : "hover:bg-primary/90"
            )}
          >
            <FileEdit className="h-6 w-6" />
            <span className="text-xs">Score</span>
          </button>
          
          <button
            onClick={() => navigate("/profile")}
            className={cn(
              "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded transition-colors",
              currentRoute.startsWith("/profile")
                ? "bg-white/20"
                : "hover:bg-primary/90"
            )}
          >
            <UserCircle className="h-6 w-6" />
            <span className="text-xs">Profile</span>
          </button>
        </footer>
      )}
    </>
  );
};

export default Layout;
